import { CompassIcon, HelpCircleIcon } from '@hugeicons/react'
import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export type LevelPlayStartBadgeKind = 'journey' | 'quiz'

const BADGE_LABEL: Record<LevelPlayStartBadgeKind, string> = {
  journey: 'JORNADA',
  quiz: 'QUIZ'
}

export type LevelPlayStartBadgeSize = 'sm' | 'md'

export interface LevelPlayStartBadgeProps {
  kind: LevelPlayStartBadgeKind
  icon?: ReactNode
  size?: LevelPlayStartBadgeSize
  className?: string
}

const ICON_SIZE: Record<LevelPlayStartBadgeSize, number> = {
  sm: 10,
  md: 12
}

const defaultIcon = (
  kind: LevelPlayStartBadgeKind,
  size: LevelPlayStartBadgeSize
) => {
  const px = ICON_SIZE[size]

  if (kind === 'journey') {
    return (
      <CompassIcon
        size={px}
        variant="stroke"
        aria-hidden
        className="shrink-0"
      />
    )
  }

  return (
    <HelpCircleIcon
      size={px}
      variant="stroke"
      aria-hidden
      className="shrink-0"
    />
  )
}

export const LevelPlayStartBadge = ({
  kind,
  icon,
  size = 'sm',
  className
}: LevelPlayStartBadgeProps) => (
  <div
    className={cn(
      'inline-flex items-center rounded-full bg-brand-light font-semibold uppercase tracking-wide text-brand-text',
      size === 'sm'
        ? 'gap-1 px-2 py-0.5 text-[10px] leading-none'
        : 'gap-1.5 px-2.5 py-1 text-caps',
      className
    )}
  >
    {icon ?? defaultIcon(kind, size)}
    {BADGE_LABEL[kind]}
  </div>
)
